
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's49cbb899f39d446c': `None available`,
's5efd695469fdfbc7': `Drop ZIP file`,
's3914cb410fca44d4': `Import`,
'sdcf7cff5142442e6': `Toggle fullscreen`,
's12e9c9d9d9b94cf1': `Screenshot`,
'sd9ad53251f2330a5': `Stop`,
's8a4ff2bd9c13498c': `Record`,
's1cfec4d5cba2e56c': `Motion Group`,
's191bbfc4126e2367': `Motion`,
's6ab73c998850c5ab': `Expression`,
'sb32cad250448883a': `Stop recording`,
'sa9da29c2219e79d4': `Start recording`,
's0fae70085395a77b': `Export resolution`,
'safebfdf2495fa963': `Viewport`,
'sf0cab2483f66aa2e': `Custom`,
's81a28b03c630b0b4': `Custom export width`,
's259a6b881cae3f83': `Custom export height`,
's54d1b2a64667e32e': `Camera`,
's8dd37619f42fa90c': `Pan`,
's166bd56d19670a72': `Zoom`,
's1db6360db0fbd814': `Pan X`,
's1db6370db0fbd9c7': `Pan Y`,
's2706a162264c46f1': `Scale`,
's255857544a9d5ec0': `Reset`,
's21b06c38fc4164db': `Advanced`,
'scc8c6c80277c1d89': `Resolution scale`,
's0b0a02a4470de153': `Device`,
's07f84a07b4b98e4c': `1x`,
's41de11f116525cf3': `1.5x`,
's08034c07b4c39937': `2x`,
'sd745ea0ba1e14cec': `2.5x`,
's07ff4607b4bfa62e': `3x`,
'see3ba305d75e09c9': `Framing guide`,
'sdaa6b536b76a65f5': `Mouse tracking`,
    };
  